import { ReportDataSource } from 'src/api';

export const enrtiesDataSource = Object.keys(ReportDataSource).map((key) => key);
